import { initCSRToolbar } from "tsi-common-react/src/apps/csr";
import { registerCascades } from "tsi-common-react/src/store/common/cascades";

import { rehydratingStore, store } from "./store";

// Register store cascades
registerCascades(store);

// Render the CSR toolbar
initCSRToolbar({
    rehydratingStore,
    store,
}).catch(console.error);
